/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $AddProfessionalSpecialtiesRequest = {
  properties: {
    professionalId: {
      type: 'string',
      isRequired: true,
    },
    specialties: {
      type: 'array',
      contains: {
        type: 'ExtraSpecialty',
      },
      isRequired: true,
    },
  },
} as const;
